import styled from 'styled-components'

import NumberInput from './number-input'

interface IProps {
  value: number
  setValue: (value: number) => void
}

export default function StoneScore({ value, setValue }: IProps) {
  return (
    <Container>
      <NumberInput setValue={setValue} value={value} />
    </Container>
  )
}

const Container = styled.div`
  align-items: center;
  border-bottom: solid 1px #bc9b33;
  display: flex;
  flex-direction: column;
  height: 7.5%;
  justify-content: center;
  width: 100%;
`
